import React from 'react';
import { Select } from '@fourthwall/components';
import { useDateRange, usePrecision } from '@fourthwall/module-analytics';
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { REPORT_TYPES } from '../../../../consts';
import { useReportType } from '../../../../hooks/useReportType';
import * as S from './PrecisionSelect.styled';
export const PrecisionSelect = ({ excludedPrecision }) => {
    const { getCurrentShopTime } = useShopTime();
    const { reportType } = useReportType();
    const { dateRange } = useDateRange(getCurrentShopTime());
    const { precision } = usePrecision(dateRange.value, excludedPrecision);
    if (!REPORT_TYPES[reportType].precision)
        return null;
    return (React.createElement(S.Container, null,
        React.createElement(Select, { label: "Group by", options: precision.select.options, disabled: precision.select.options.length === 1, size: "medium", value: precision.select.value, onValueChange: precision.select.onValueChange })));
};
